var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('joy-page',{attrs:{"joyPageStatus":_vm.joyPageStatus}},[_c('van-cell',{attrs:{"title":"微信号","icon":"comment","value":_vm.listData.wechat}}),_c('van-cell',{attrs:{"title":"电话号码","icon":"phone","value":_vm.listData.phone}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }